<div class="tab-content match-summary live-timeline baseball-timeline-container">
    @for (val of actions; track $index) {
        <div
            class="tab-pane show active"
            id="tab-match-summary-1-content"
            role="tabpanel"
            aria-labelledby="tab-match-summary-1"
        >
            @if (!isUnknown) {
                <h6
                    class="text-center text-uppercase match-summary__head dropdown-toggle"
                    data-toggle="collapse"
                    [attr.href]="'#collapseAction' + val[0]"
                    role="button"
                    aria-expanded="false"
                    [attr.aria-controls]="'collapseAction' + val[0]"
                >
                    {{ 'web.' + sportName + '_' + val[0] | lowercase | translate }}
                </h6>
            }
            <div class="collapse show" [attr.id]="'collapseAction' + val[0]">
                @for (action of val[1]; track $index; let isLastMain = $last; let rowIndex = $index) {
                    <div class="">
                        <div
                            data-toggle="collapse"
                            [attr.href]="'#collapseTimelineEvent' + action.id"
                            role="button"
                            aria-expanded="true"
                            [attr.aria-controls]="'collapseTimelineEvent' + action.id"
                            class="baseball-timeline d-flex align-items-center no-gutters border-top py-1 px-1 small ng-star-inserted"
                        >
                            <div class="px-2 chevron-container">
                                @if (isActionCollapsible(action)) {
                                    <i class="fa timeline-chevron"></i>
                                }
                            </div>
                            @if (action.match_clock || action.match_time) {
                                <div class="px-1">
                                    <span>{{ action.match_clock || action.match_time }}</span>
                                </div>
                            }
                            <div class="px-1">
                                @if (participant(action.competitor)?.image !== null) {
                                    <img
                                        [src]="participant(action.competitor)?.image"
                                        [alt]="participant(action.competitor)?.name"
                                        height="40"
                                        width="40"
                                        style="object-fit: contain"
                                        class="mr-1"
                                    />
                                }
                                @if (participant(action.competitor)?.image === null) {
                                    <img
                                        [src]="'/img/default-logo.svg'"
                                        [alt]="participant(action.competitor)?.name"
                                        height="40"
                                        width="40"
                                        style="object-fit: contain; visibility: hidden"
                                        class="mr-1"
                                    />
                                }
                            </div>
                            <div class="flex-grow-1 pr-2">
                                <div class="font-0-8x font-weight-bold">
                                    {{ participant(action.competitor)?.name }} -
                                    {{ 'web.baseball_half_' + action.half | lowercase | translate }}
                                    {{
                                        '' //'web.timeline_baseball_type_' + action.type + '_short' | translate
                                    }}
                                </div>
                                <div class="text-muted small">
                                    {{ action.description }}
                                </div>
                            </div>
                            @if (true) {
                                <div class="pr-2 text-center">
                                    <div class="text-muted small">
                                        {{ participant('home')?.alias }}
                                    </div>
                                    <div
                                        class="font-weight-bold font-1x"
                                        [ngClass]="{ 'emph-text-node': action.competitor === 'home' }"
                                    >
                                        {{ action.home_score }}
                                    </div>
                                </div>
                            }
                            @if (true) {
                                <div class="pr-2 text-center">
                                    <div class="text-muted small">
                                        {{ participant('away')?.alias }}
                                    </div>
                                    <div
                                        class="font-weight-bold font-1x"
                                        [ngClass]="{ 'emph-text-node': action.competitor === 'away' }"
                                    >
                                        {{ action.away_score }}
                                    </div>
                                </div>
                            }
                        </div>
                        @if (isActionCollapsible(action)) {
                            <div
                                class="collapse show action-additional-info py-2"
                                [attr.id]="'collapseTimelineEvent' + action.id"
                            >
                                @for (player of action.players; track $index) {
                                    <div class="d-flex">
                                        <div class="img-circle img-circle--40 mr-3 rounded-circle">
                                            <img
                                                (error)="imageError($event, 'avatar')"
                                                [attr.alt]="player?.name"
                                                [src]="'/assets/players/photos/' + player?.id + '.png'"
                                                height="40"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div class="pb-2">
                                            <div class="font-0-8x">
                                                <span class="font-weight-bold">
                                                    <a
                                                        [routerLink]="[
                                                            '/page/sport/player',
                                                            sportName + '-' + sportId,
                                                            player.id,
                                                        ]"
                                                        class="text-reset"
                                                        >{{ player.name }}</a
                                                    >
                                                </span>
                                                {{
                                                    player?.participant
                                                        ? '(' +
                                                          (player.participant.alias ?? player.participant.name) +
                                                          ')'
                                                        : ''
                                                }}
                                            </div>
                                            <div class="text-muted small">
                                                {{
                                                    'web.' + this.sportName + '_timeline-player-type_' + player.type
                                                        | translate
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                }

                                @if (action?.events) {
                                    <table class="table-scrollable__data__table mt-3 mb-1">
                                        <thead>
                                            <tr>
                                                <th class="table-scrollable__table-th" colspan="2">
                                                    {{ 'web.baseball_timeline_event_pitch' | translate }}
                                                </th>
                                                <th class="table-scrollable__table-th">
                                                    {{ 'web.baseball_timeline_event_type' | translate }}
                                                </th>
                                                <th class="table-scrollable__table-th text-right">
                                                    {{ 'web.baseball_timeline_event_speed' | translate }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (e of action.events; track $index) {
                                                <tr class="table-scrollable__table-row">
                                                    <td class="table-scrollable__table-td text-right">
                                                        <span class="{{ e.outcome_id ? 'mlb-tl-outcome mlb-tl-outcome-'+e.outcome_id.toLowerCase() : '' }}">{{ e.number }}</span>
                                                    </td>
                                                    <td class="table-scrollable__table-td">{{ e.name | translate }}</td>
                                                    <td class="table-scrollable__table-td">{{ e.type | translate }}</td>
                                                    <td class="table-scrollable__table-td text-right">
                                                        {{ e.speed + ' MPH' | unitConversion }}
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                }

                                @if (action?.hits !== null && action?.runs !== null && action?.errors !== null) {
                                    <div class="text-right mb-3 mr-1">
                                        <span>{{ 'web.baseball_timeline_runs' | translate }}: {{ action.runs }}</span
                                        >, <span>{{ 'web.baseball_timeline_hits' | translate }}: {{ action.hits }}</span
                                        >,
                                        <span
                                            >{{ 'web.baseball_timeline_errors' | translate }}: {{ action.errors }}</span
                                        >
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</div>
